import type { SVGProps } from 'react';

export const CancelMsg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="12.5px"
    role="img"
    viewBox="0 0 12.5 12.5"
    width="12.5px"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    {...props}
  >
    <title>{'cancel message'}</title>
    <path
      d="M7.1,6.2l5.4-5.4c0,0,0-0.1,0-0.1L11.7,0c0,0-0.1,0-0.1,0L6.2,5.4L0.9,0c0,0-0.1,0-0.1,0
      	L0,0.7c0,0,0,0.1,0,0.1l5.4,5.4L0,11.6c0,0,0,0.1,0,0.1l0.7,0.7c0,0,0.1,0,0.1,0l5.4-5.4l5.4,5.4c0,0,0,0,0.1,0s0.1,0,0.1,0l0.7-0.7
      	c0,0,0-0.1,0-0.1L7.1,6.2z"
    />
  </svg>
);
